import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import StudentNavBar from "../navbar/StudentNavBar";

export default function StudentRoute({ children }) {
  const user = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  } else if (user === "admin") {
    return <Navigate to="/admin/dashboard" />;
  } else if (user === "student") {
    return (
      <>
        <StudentNavBar />
        {children}
      </>
    );
  }
}
